module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/homepage/rough-edge-3-674b8fbafe2178fc08d95394a3eac51c.png";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/homepage/rough-edge-3.png
// module id = D0x/
// module chunks = 9